import { z } from "zod";
import { SUPPORTED_CARRIER_IDS } from "helpers/carriers";

export const Step1Schema = z
  .object({
    producer: z.string("Producer Required").min(1, "Producer cannot be empty"),
    agentEmail: z.email("Invalid email").min(1, "Agent Email Required"),
    policyDate: z
      .date("Policy Date Required")
      .refine((date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const maxDate = new Date(today);
        maxDate.setDate(maxDate.getDate() + 30);

        return date <= maxDate;
      }, {
        message: "Policy Date must be between today and 30 days from today",
      }),
    garageState: z.string("Garage State Required").min(1, "Garage State cannot be empty"),
    powerUnits: z
      .number("Power Units Required")
      .int("Power units must be a whole number")
      .min(1, "Power units must be between 1 and 40")
      .max(40, "Power units must be between 1 and 40"),
    allowedCarriers: z.array(z.string()).default([]),
    carrier: z
      .array(z.enum(SUPPORTED_CARRIER_IDS))
      .min(1, "Please select at least one carrier"),

    insuredWithProgressiveCommercialAuto: z
      .enum(["yes", "no", "na"], {
        required_error: "Please select Yes or No",
      })
      .default("na"),

    hazmatPlacard: z.boolean().default(false),
    haulDoubleTripleTrailers: z.boolean().default(false),
    operatedTwoYears: z
      .enum(["yes", "no", "na"], {
        required_error: "Please select Yes or No",
      })
      .default("na"),
    personalUseOfTrailer: z.boolean().default(false),
    personalUseOfVehicle: z.boolean().default(false),
  })
  .superRefine((data, ctx) => {
    const carrier = data?.carrier;
    if (data.hazmatPlacard && carrier.length === 1 && !carrier.includes('Accelerant')) {
      ctx.addIssue({
        code: "custom",
        path: ["hazmatPlacard"],
        message: "We cannot cover any hazardous materials at this time.",
      });
    }
    if (data.haulDoubleTripleTrailers) {
      ctx.addIssue({
        code: "custom",
        path: ["haulDoubleTripleTrailers"],
        message: "We cannot cover any double/triple trailers at this time.",
      });
    }
    if (data.insuredWithProgressiveCommercialAuto === "na" ||
      data.operatedTwoYears === "na"
    ) {
      // Add issue on the field(s) that are "na"
      const fieldsToFlag = [];
      if (data.insuredWithProgressiveCommercialAuto === "na" && carrier.includes('Progressive')) {
        fieldsToFlag.push("insuredWithProgressiveCommercialAuto");
      }
      if (data.operatedTwoYears === "na" && carrier.includes('Nirvana')) {
        fieldsToFlag.push("operatedTwoYears");
      }
      fieldsToFlag.forEach((field) => {
        ctx.addIssue({
          code: "custom",
          path: [field],
          message: "Please select Yes or No",
        });
      });
    }
  });
